module.exports = __webpack_public_path__ + "img/P8_popup_thumb_6_th.ad41c4ca.png";